import React from 'react';
import PropTypes from 'prop-types';
import './Icons.scss';

function Close({ onClick }) {
  return (
    <div className="icon-close" onClick={onClick}>
      ✕
    </div>
  );
}

Close.propTypes = {
  onClick: PropTypes.func,
};

export default Close;
